import { Routes, ResolveFn } from '@angular/router';
//import { ThanksforsubscribingComponent } from './components/thanksforsubscribing/thanksforsubscribing.component';
import { HomepageNew } from './components/homepage-new/homepage-new';
import { inject } from '@angular/core';
import { PageSectionService } from './services/PageSection.service';
import { firstValueFrom } from 'rxjs';
import { tap } from 'rxjs/operators';


let cachedPageData: any = null;
let cacheTimestamp: number = 0;
const CACHE_DURATION = 15 * 60 * 1000; // 15 minutes cache

export const homePageResolver: ResolveFn<any> = () => {
    const now = Date.now();
    if (cachedPageData && (now - cacheTimestamp < CACHE_DURATION)) {
        return cachedPageData;
    }
    return firstValueFrom(
        inject(PageSectionService).get_page_data({ slug: 'home' }).pipe(
            tap(data => {
                if (data && data.response === 'success') {
                    cachedPageData = data;
                    cacheTimestamp = Date.now();
                }
            })
        )
    ).catch(err => {
        console.error('Resolver failed to fetch page data:', err);
        return cachedPageData || null;
    });
};

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('./components/homepage-new/homepage-new').then(m => m.HomepageNew),
        resolve: { pageData: homePageResolver }
    },
    {
        path: 'login',
        loadChildren: () => import('./components/login/login.routes').then(m => m.LoginRoute)
    },
    {
        path: 'influencer-login',
        loadChildren: () => import('./components/influencer-login/influencer-login.routes').then(m => m.InfluencerLoginRoute)
    },
    {
        path: 'notifications',
        loadChildren: () => import('./components/notifications/notifications.routes').then(m => m.NotificationsRoute)
    },
    {
        path: 'locations',
        loadChildren: () => import('./components/countries-locations/countries-locations.routes').then(m => m.CountriesLocationsRoute)
    },
    {
        path: 'experience',
        loadChildren: () => import('./components/experiences-listing/experiences-listing.routes').then(m => m.ExperiencesListingRoute)
    },
    {
        path: 'google-callback',
        loadChildren: () => import('./components/callBack/callBack.routes').then(m => m.CallBackRoute)

    },
    {
        path: 'thanksforsubscribing',
        loadChildren: () => import('./components/thanksforsubscribing/thanksforsubscribing.routes').then(m => m.ThanksforsubscribingRoute)
    },
    {
        path: 'registration/charity',
        loadChildren: () => import('./components/register/charity/charity.routes').then(m => m.ChairtyRoute)
    },
    {
        path: 'about',
        loadChildren: () => import('./components/about/about.routes').then(m => m.AboutRoute)
    },
    {
        path: 'app',
        loadChildren: () => import('./components/app-page/app-page.routes').then(m => m.AppPageRoute)
    },
    {
        path: 'find-couple',
        loadChildren: () => import('./components/find-couple/find-couple.routes').then(m => m.FindCoupleRoute)
    },
    {
        path: 'registration/wedding-couple',
        loadChildren: () => import('./components/register/wedding-couple/wedding-couple.routes').then(m => m.WeddingCoupleRoute)
    },

    {
        path: 'registration/individual',
        loadChildren: () => import('./components/register/individual/individual.routes').then(m => m.IndividualRoute)
    },
    {
        path: 'registration/experience-provider',
        loadChildren: () => import('./components/register/experience-provider/experience-provider.routes').then(m => m.ExperienceProviderRoute)
    },
    {
        path: 'registration/bbb-registration',
        loadChildren: () => import('./components/register/bbb/bbb.routes').then(m => m.BBBRoute)
    },

    {
        path: 'add-experiences',
        loadChildren: () => import('./components/add-user-experience/add-user-experience.routes').then(m => m.AddExperienceRoute)
    },
    {
        path: 'connections',
        loadChildren: () => import('./components/connections/connections.routes').then(m => m.ConnectionsRoute)
    },
    {
        path: 'gift-tracker',
        loadChildren: () => import('./components/gift-tracker/gift-tracker.routes').then(m => m.GiftTrackerRoute)
    },
    {
        path: 'sendoso',
        loadChildren: () => import('./components/additional-users/additional-users.routes').then(m => m.AdditionalUsersRoute)
    },
    {
        path: 'sendoso-shop',
        loadChildren: () => import('./components/sendoso-shop/sendoso-shop.routes').then(m => m.SendosoRoute)
    },
    {
        path: 'postal',
        loadChildren: () => import('./components/additional-users/additional-users.routes').then(m => m.AdditionalUsersRoute)
    },
    {
        path: 'postal-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'inbox',
        loadChildren: () => import('./components/inbox/inbox.routes').then(m => m.InboxRoute)
    },
    {
        path: 'influencer-ep-inbox',
        loadChildren: () => import('./components/influencer-ep-inbox/influencer-ep-inbox.routes').then(m => m.InfluencerEpInboxRoute)
    },
    {
        path: 'artical-detail',
        loadChildren: () => import('./components/artical-details/artical-details.routes').then(m => m.ArticalDetailsRoute)

    },
    {
        // Admin slug rename: typo "qhat" → "what"
        path: 'blog/a-grooms-wedding-registry-qhat-men-actually-want',
        redirectTo: 'blog/a-grooms-wedding-registry-what-men-actually-want',
        pathMatch: 'full'
    },
    {
        path: 'blogs/a-grooms-wedding-registry-qhat-men-actually-want',
        redirectTo: 'blog/a-grooms-wedding-registry-what-men-actually-want',
        pathMatch: 'full'
    },
    {
        path: 'blog-detail/a-grooms-wedding-registry-qhat-men-actually-want',
        redirectTo: 'blog/a-grooms-wedding-registry-what-men-actually-want',
        pathMatch: 'full'
    },
    {
        path: 'blog',
        loadChildren: () => import('./components/blog/blog.routes').then(m => m.BlogRoute)
    },
    {
        path: 'blogs',
        redirectTo: 'blog',
        pathMatch: 'full'
    },
    {
        path: 'blogs/page/:pageNumber',
        redirectTo: 'blog/page/:pageNumber'
    },
    {
        path: 'blogs/:slug',
        redirectTo: 'blog/:slug'
    },
    {
        path: 'blog-detail/:slug',
        redirectTo: 'blog/:slug'
    },
    {
        path: 'category-blog/:slug',
        loadChildren: () => import('./components/category-blog/category-blog.routes').then(m => m.CategoryBlogRoute)
    },
    {
        path: 'cart',
        loadChildren: () => import('./components/cart/cart.routes').then(m => m.CartRoute)
    },
    {
        path: 'charities',
        loadChildren: () => import('./components/charity/charity.routes').then(m => m.CharityRoute)
    },
    {
        path: 'charity-category/:string',
        loadChildren: () => import('./components/charity-category/charity-category.routes').then(m => m.CharityCategoryRoute)
    },
    {
        path: 'experience-provider-add',
        loadChildren: () => import('./components/add-experience-provider/add-experience-provider.routes').then(m => m.AddExperienceProviderRoute)
    },
    {
        path: 'shop',
        loadChildren: () => import('./components/experience-shop/experience-shop.routes').then(m => m.ExperienceShopRoute)
    },
    {
        path: 'charity-couple',
        loadChildren: () => import('./components/charity-couple/charity-couple.routes').then(m => m.CharityCoupleRoute)
    },
    {
        path: 'gratuity-checkout',
        loadChildren: () => import('./components/gratuity-checkout/gratuity-checkout.routes').then(m => m.GratuityCheckoutRoute)
    },
    {
        path: 'checkout-old',
        loadChildren: () => import('./components/checkout/checkout.routes').then(m => m.CheckoutRoute)
    },
    {
        path: 'checkout',
        loadChildren: () => import('./components/checkout-new/checkout.routes').then(m => m.CheckoutRoute)
    },
    {
        path: 'claim-voucher',
        loadChildren: () => import('./components/claim-voucher/claim-voucher.routes').then(m => m.ClaimVoucherRoute)
    },
    {
        path: 'continents/:slug',
        loadChildren: () => import('./components/continent/continent.routes').then(m => m.ContinentRoute)
    },
    {
        path: 'continents/:slug/:slug',
        loadChildren: () => import('./components/continent/continent.routes').then(m => m.ContinentRoute)
    },
    {
        path: 'customer-support',
        loadChildren: () => import('./components/customer-support/customer-support.routes').then(m => m.CustomerSupportRoute)
    },
    {
        path: 'edit-experience',
        loadChildren: () => import('./components/ep-dashboard/edit-experience/edit-experience.routes').then(m => m.EditExperienceRoute)
    },
    {
        path: 'booking-calendar',
        loadChildren: () => import('./components/ep-dashboard/ep-booking-calender/ep-booking-calender.routes').then(m => m.EpBookingCalenderRoute)
    },
    {
        path: 'edit-charity',
        loadChildren: () => import('./components/edit-charity/edit-charity.routes').then(m => m.EditCharityRoute)
    },
    {
        path: 'provider/ep-providers/:slug',
        loadChildren: () => import('./components/ep-providers/ep-providers.routes').then(m => m.EpProvidersRoute)
    },
    {
        path: 'experiences/:slug',
        loadChildren: () => import('./components/exp-detail-new/exp-detail-new.routes').then(m => m.ExpDetailNewRoute)
    },
    {
        path: 'experience',
        loadChildren: () => import('./components/experiences/experiences.routes').then(m => m.ExperienceRegionCategoryRoute)
    },
    {
        path: 'experience-search-booking',
        loadChildren: () => import('./components/experience-search-booking/experience-search-booking.routes').then(m => m.ExperienceSearchBookingRoute)
    },
    {
        path: 'hotels-list',
        loadChildren: () => import('./components/hotels-list/hotels-list.routes').then(m => m.HotelsListRoute)
    },
    {
        path: 'faqs',
        loadChildren: () => import('./components/faqs/faqs.routes').then(m => m.FaqsRoute)
    },
    {
        path: 'faq-cate-details/:string',
        loadChildren: () => import('./components/faq-cate-details/faq-cate-details.routes').then(m => m.FaqCateDetailsRoute)
    },
    {
        path: 'faq-category/:string',
        loadChildren: () => import('./components/faq-category/faq-category.routes').then(m => m.FaqCategoryRoute)
    },
    {
        path: 'gift-card',
        loadChildren: () => import('./components/gift-card/gift-card.routes').then(m => m.GiftCardRoute)
    },
    {
        path: 'list-influencers',
        loadChildren: () => import('./components/list-influencers/list-influencers.routes').then(m => m.ListInfluencersdRoute)
    },
    {
        path: 'influencer/:slug',
        loadChildren: () => import('./components/influencer-details/influencer-details.routes').then(m => m.InfluencerDetailRoute),
    },
    {
        path: 'gifts',
        loadChildren: () => import('./components/gift-ideas-NEW/gift-ideas.routes').then(m => m.GiftIdeasRoute)
    },
    {
        path: 'gifts/:slug',
        loadChildren: () => import('./components/gift-ideas-NEW/gift-category-NEW/gift-category.routes').then(m => m.GiftCategoryRoute)
    },
    {
        path: 'gift-ideas',
        redirectTo: 'gifts',
        pathMatch: 'full'
    },
    {
        path: 'gift-ideas-category/:slug',
        redirectTo: 'gifts/:slug'
    },
    {
        path: 'gift-ideas-category/:slug/:country',
        redirectTo: 'gifts/:slug/:country'
    },
    {
        path: 'gift-ideas-category/:slug/:country/:state',
        redirectTo: 'gifts/:slug/:country/:state'
    },

    {
        path: 'experience/:slug',
        loadChildren: () => import('./components/high-level-category-NEW/high-level-category.routes').then(m => m.HighLevelCategoryRoute)
    },
    {
        path: 'at-home-experiences',
        loadChildren: () => import('./components/home-exp/home-experience.routes').then(m => m.HomeExperienceRoute)
    },
    {
        path: 'howitwork',
        loadChildren: () => import('./components/how-it-work/how-it-work.routes').then(m => m.HowItWorkRoute)
    },
    {
        path: 'influencers',
        loadChildren: () => import('./components/influencer/influencer.routes').then(m => m.InfluencerRoute)
    },
    {
        path: 'spurfect-rewards',
        loadChildren: () => import('./components/spurfect-rewards/spurfect-rewards.routes').then(m => m.SpurfectRewardsRoute)
    },
    {
        path: 'spurfect-rewards/:slug',
        loadChildren: () => import('./components/spurfect-rewards-shop/spurfect-rewards-shop.routes').then(m => m.SpurfectRewardsShopRoute)
    },
    {
        path: 'spurfect-reward-quiz',
        loadChildren: () => import('./components/spurfect-reward-quiz/spurfect-reward-quiz.routes').then(m => m.SpurfectRewardQuizRoute)
    },
    {
        path: 'joy',
        loadChildren: () => import('./components/additional-users/additional-users.routes').then(m => m.AdditionalUsersRoute)
    },
    {
        path: 'knot',
        loadChildren: () => import('./components/additional-users/additional-users.routes').then(m => m.AdditionalUsersRoute)
    },
    {
        path: 'gravity-haus',
        loadChildren: () => import('./components/additional-users/additional-users.routes').then(m => m.AdditionalUsersRoute)
    },
    {
        path: 'theknot',
        loadChildren: () => import('./components/additional-users/additional-users.routes').then(m => m.AdditionalUsersRoute)
    },
    {
        path: 'tk',
        loadChildren: () => import('./components/additional-users/additional-users.routes').then(m => m.AdditionalUsersRoute)
    },
    {
        path: 'withjoy',
        loadChildren: () => import('./components/additional-users/additional-users.routes').then(m => m.AdditionalUsersRoute)
    },
    {
        path: 'ally-bank',
        loadChildren: () => import('./components/additional-users/additional-users.routes').then(m => m.AdditionalUsersRoute)
    },
    {
        path: 'locations/:string',
        loadChildren: () => import('./components/location/location.routes').then(m => m.LocationRoute)
    },
    {
        path: 'location-region',
        loadChildren: () => import('./components/location-region-new/location-region.routes').then(m => m.LocationRegionRoute)
    },
    {
        path: 'lostPass',
        loadChildren: () => import('./components/lost-password/lost-password.routes').then(m => m.LostPasswordRoute)
    },
    {
        path: 'reset-password',
        loadChildren: () => import('./components/reset-password/reset-password.routes').then(m => m.ResetPasswordRoute)
    },
    {
        path: 'vebo-map-app-view',
        loadChildren: () => import('./components/map-app-view/map-app-view.routes').then(m => m.MapAppViewRoute)
    },
    {
        path: 'master-login/:string',
        loadChildren: () => import('./components/master-login/master-login.routes').then(m => m.MasterLoginRoute)
    },
    {
        path: 'partner-signup/:string',
        loadChildren: () => import('./components/partner-signup/partner-signup.routes').then(m => m.PartnerSignupRoute)
    },
    {
        path: 'influencer-details',
        loadChildren: () => import('./components/individual-after-login/influencer-details/influencer-details.routes').then(m => m.InfluencerDetailRoute)
    },
    {
        path: 'my-friends',
        loadChildren: () => import('./components/my-friends/my-friends.routes').then(m => m.MyFriendsRoute)
    },
    {
        path: 'payment-failed',
        loadChildren: () => import('./components/payment-failed/payment-failed.routes').then(m => m.PaymentFailedRoute)
    },
    {
        path: 'paypal-response',
        loadChildren: () => import('./components/paypal-response/paypal-response.routes').then(m => m.PaypalResponseRoute)
    },
    {
        path: 'persona-landing',
        loadChildren: () => import('./components/persona-landing/persona-landing.routes').then(m => m.PersonaLandingRoute)
    },
    {
        path: 'press',
        loadChildren: () => import('./components/press/press.routes').then(m => m.PressRoute)
    },
    {
        path: 'profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'ep-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'ep-overview',
        loadChildren: () => import('./components/ep-dashboard/ep-dashboard.routes').then(m => m.EpDashboardRoute)
    },
    {
        path: 'bbb-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'knot-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'joy-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'zola-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'sendoso-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'thnks-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'your-profile/charity',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'my-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'gravity-haus-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'ally-bank-profile',
        loadChildren: () => import('./components/profile/profile.routes').then(m => m.ProfileRoute)
    },
    {
        path: 'providers',
        loadChildren: () => import('./components/providers/providers.routes').then(m => m.ProvidersRoute)
    },
    {
        path: 'registries/:string',
        loadChildren: () => import('./components/registries/registries.routes').then(m => m.RegistriesRoute)
    },
    {
        path: 'user-profile/:string',
        loadChildren: () => import('./components/registries/registries.routes').then(m => m.RegistriesRoute)
    },
    {
        path: 'track-sale',
        loadChildren: () => import('./components/registerfinder-after-login/track-sale/track-sale.routes').then(m => m.TrackSaleRoute)
    },
    {
        path: 'track-referal-link',
        loadChildren: () => import('./components/registerfinder-after-login/track-referal/track-referal.routes').then(m => m.TrackReferalRoute)
    },
    // {
    //     path: 'track-sale',
    //     loadChildren: () => import('./components/registerfinder-after-login/registerfinder.routes').then(m => m.RegisterfinderRoute)
    // },
    {
        path: 'settings',
        loadChildren: () => import('./components/settings/settings.routes').then(m => m.SettingsRoute)
    },
    {
        path: 'my-settings',
        loadChildren: () => import('./components/settings/settings.routes').then(m => m.SettingsRoute)
    },
    {
        path: 'experience-settings',
        loadChildren: () => import('./components/ep-dashboard/experience-settings/experience-settings.routes').then(m => m.SettingsRoute)
    },
    {
        path: 'experience-availability',
        loadChildren: () => import('./components/ep-dashboard/exp-availability/exp-availability.routes').then(m => m.ExpAvailabilityRoute)
    },
    {
        path: 'exp-booking',
        loadChildren: () => import('./components/ep-dashboard/exp-booking/exp-booking.routes').then(m => m.ExpBookingRoute)
    },
    {
        path: 'your-profile/experience-provider',
        loadChildren: () => import('./components/ep-dashboard/voucher-redeem/voucher-redeem.routes').then(m => m.VoucherRedeemRoute)
    },
    {
        path: 'charity-settings',
        loadChildren: () => import('./components/settings/settings.routes').then(m => m.SettingsRoute)
    },
    {
        path: 'thankyou-booking',
        loadChildren: () => import('./components/thank-you/thank-you.routes').then(m => m.ThankYouRoute)
    },
    {
        path: 'thankyou',
        loadChildren: () => import('./components/thank-you/thank-you.routes').then(m => m.ThankYouRoute)
    },
    {
        path: 'thank-you',
        loadChildren: () => import('./components/thank-you-order/thank-you-order.routes').then(m => m.ThanksYouOrderRoute)
    },
    {
        path: 'tiktok',
        loadChildren: () => import('./components/tiktok/tiktok.routes').then(m => m.TiktokRoute)
    },
    {
        path: 'tickets',
        loadChildren: () => import('./components/tickets-page/tickets-page.routes').then(m => m.TicketsPageRoute)
    },
    {
        path: 'ticket-map-web-view',
        loadChildren: () => import('./components/ticket-map-web-view/ticket-map-web-view.routes').then(m => m.TicketMapWebViewRoute)
    },
    {
        path: 'top-ten-category',
        loadChildren: () => import('./components/top-ten-category/top-ten-category.routes').then(m => m.TopTenCategoryRoute)
    },
    {
        path: 'spur-seats',
        loadChildren: () => import('./components/ticket-details-page/ticket-details-page.routes').then(m => m.TicketDetailsPageRoute)
    },
    // {
    //     path: '',
    //     loadChildren: () => import('./components/veboticketing/veboticketing.routes').then(m => m.VeboTicketingRoute)
    // },
    {
        path: 'ticket-category',
        loadChildren: () => import('./components/veboticketing/all-events/all-events.routes').then(m => m.AllEventRoute)
    },
    {
        path: 'our-tickets',
        loadChildren: () => import('./components/veboticketing/our-tickets/our-tickets.routes').then(m => m.OurTicketsRoute)
    },
    {
        path: 'view-all-voucher',
        loadChildren: () => import('./components/view-all-voucher/view-all-voucher.routes').then(m => m.ViewAllVoucherRoute)
    },
    {
        path: 'wedding-registry',
        loadChildren: () => import('./components/weddingregistry/weddingregistry.routes').then(m => m.WeddingregistryRoute)
    },
    {
        path: 'registry',
        loadChildren: () => import('./components/wedding-couple-registry/wedding-couple-registry.routes').then(m => m.WeddingCoupleRegistryRoute)
    },
    /*
    **{
        path: 'weddingregistry',
        loadChildren: () => import('./components/weddingregistry/weddingregistry.routes').then(m => m.WeddingregistryRoute)
    },
    */
    {
        path: 'whyregisterwithspur',
        loadChildren: () => import('./components/whyregisterwithcouple/whyregisterwithcouple.routes').then(m => m.WhyregisterwithcoupleRoute)
    },
    {
        path: 'zola',
        loadChildren: () => import('./components/additional-users/additional-users.routes').then(m => m.AdditionalUsersRoute)
    },
    {
        path: 'influencer-get-started',
        loadChildren: () => import('./components/influencer-onboarding/influencer-onboarding.routes').then(m => m.InfluencerOnboardingRoute)
    },
    {
        path: '**',
        loadChildren: () => import('./components/not-found/not-found.routes').then(m => m.NotFoundRoute)
    },
    {
        path: '404',
        loadChildren: () => import('./components/not-found/not-found.routes').then(m => m.NotFoundRoute)
    },

];
